import { Molecule } from 'AppReact';
import styled, { css } from 'styled-components';
import { getInitials } from 'utils/getInitials';
import { Image, Initials } from './atoms';

const template = styled.div`
  ${({ displayState }) => css`
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    width:  100px;
    height: 100px;
    border-radius: 50%;
    border: ${displayState.size === 'big' ? '8px' : displayState.size === 'small' ? '4px' : displayState.size === 'vSmall' ? '2px' : '5px'} solid transparent;
    background-size: 100% 100%, 80% 80%, 80% 80%;
    background-repeat: no-repeat;
    background-image: linear-gradient(white, white), 
                        linear-gradient(#1DBD6B 36%, #1DBD6B 30%),
                        linear-gradient(#867DEA 36%, #867DEA 30%),
                        linear-gradient(#FFC700 36%, #FFC700 30%);
    background-position: center center, left top, right top, left bottom, right bottom;
    background-origin: content-box, border-box, border-box, border-box, border-box;
    background-clip: content-box, border-box, border-box, border-box, border-box;

    @media only screen and (min-width: 768px) {
      width: ${displayState.size === 'big' ? '140px' : displayState.size === 'small' ? '84px' : displayState.size === 'vSmall' ? '32px' : '123px'};
      height: ${displayState.size === 'big' ? '140px' : displayState.size === 'small' ? '84px' : displayState.size === 'vSmall' ? '32px' : '123px'};
    }
  `}
`;

export default Molecule({
  template,
  atoms: [
    {
      component: Image,
      name: 'Image',
      displayValue: ({ image }) => image,
      displayState: ({ image, size }) => ({ hidden: !image, size })
    },
    {
      component: Initials,
      name: 'Initials',
      displayValue: ({ name }) => getInitials(name).slice(0, 3),
      displayState: ({ image, size }) => ({ hidden: image, size })
    },
  ],
})